module.exports = __webpack_public_path__ + "img/company.ac20caea.svg";